<template>

    <div>
        <form class="needs-validation" novalidate>
            <!-- ***** start custom content ***** -->
            <h1>{{$t('voter_list')}}</h1>

            <h2 class="mb-3">{{$t('step_2_verification')}}</h2>

            <fieldset>
                <legend>{{$t('personal_information')}}</legend>
                <div class="form-row">
                    <div class="col-md-5 mb-3">
                        <label for="firstName">{{$t('first_name')}}</label>
                        <input id="firstName" type="text" class="form-control" v-model="first_name" required>
                        <div class="invalid-feedback">{{$t('valid_first')}}</div>
                    </div>
                    <div class="col-md-5 mb-3">
                        <label for="lastName">{{$t('last_name')}}</label>
                        <input id="lastName" type="text" class="form-control" v-model="last_name" required>
                        <div class="invalid-feedback">{{$t('valid_last')}}</div>
                    </div>
                </div>
                <h2 class="h6 mt-3">{{$t('date_of_birth')}}</h2>
                <p>{{$t('eligibigle_to_vote_note')}}</p>
                <div class="form-row">
                    <div class="col-7 col-md-3 mb-3">
                        <label for="monthOfBirth">{{$t('month')}}</label>
                        <select id="monthOfBirth" class="custom-select" v-model="birth_month" required>
                            <option value="01">{{$t('january')}}</option>
                            <option value="02">{{$t('february')}}</option>
                            <option value="03">{{$t('march')}}</option>
                            <option value="04">{{$t('april')}}</option>
                            <option value="05">{{$t('may')}}</option>
                            <option value="06">{{$t('june')}}</option>
                            <option value="07">{{$t('july')}}</option>
                            <option value="08">{{$t('august')}}</option>
                            <option value="09">{{$t('september')}}</option>
                            <option value="10">{{$t('october')}}</option>
                            <option value="11">{{$t('november')}}</option>
                            <option value="12">{{$t('december')}}</option>
                        </select>
                        <div class="invalid-feedback">{{$t('valid_month')}}</div>
                    </div>
                    <div class="col-12 col-md-9">
                        <div class="form-row">
                            <div class="col-sm-2 col-2 mb-3">
                                <label for="dayOfBirth">{{$t('day')}}</label>
                                <input type="text" id="dayOfBirth" class="form-control" v-model="birth_day" required>
                                <small class="form-text text-muted">
                                    {{$t('dd')}}
                                </small>
                                <div class="invalid-feedback">
                                    {{$t('valid_day')}}
                                </div>
                            </div>
                            <div class="col-sm-3 col-3 mb-3">
                                <label for="yearOfBirth">{{$t('year')}}</label>
                                <input type="text" id="yearOfBirth" class="form-control" v-model="birth_year" required>
                                <small class="form-text text-muted">
                                    {{$t('yyyy')}}
                                </small>
                                <div class="invalid-feedback">
                                    {{$t('valid_year')}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </fieldset>
            <fieldset>
                <legend>{{$t('address_information')}}</legend>
                <div class="form-row">
                    <div class="col mb-3">
                        <div class="row">
                            <div class="col">
                                <label for="streetNumber">{{$t('street_number')}}</label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-3">

                                <input id="streetNumber" type="text" class="form-control" v-model="street_number" required>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form-row">
                    <div class="col-md-5 mb-3">
                        <label for="streetName">{{$t('street_name')}}</label>
                        <input id="streetName" type="text" class="form-control" v-model="street_name" required>
                        <small class="form-text text-muted">
                            {{$t('street_name_note')}}
                        </small>
                    </div>
                    <div class="col-md-4 mb-3">
                        <label for="streetType">{{$t('street_type')}}</label>
                        <input id="streetType" type="text" class="form-control" v-model="street_type" required>
                        <small class="form-text text-muted">
                            {{$t('street_type_note')}}
                        </small>
                    </div>
                </div>
            </fieldset>
            <fieldset>
                <legend class="h6">{{$t('step_2_recently_moved')}}</legend>
                <div class="custom-control custom-radio">
                    <input type="radio" id="recentlymovedyes" name="recentlymoved" value="Yes" required v-model="recently_moved" class="custom-control-input">
                    <label class="custom-control-label" for="recentlymovedyes">{{$t('yes')}}</label>
                </div>
                <div class="custom-control custom-radio">
                    <input type="radio" id="recentlymovedno" name="recentlymoved" value="No" required v-model="recently_moved" class="custom-control-input">
                    <label class="custom-control-label" for="recentlymovedno">{{$t('no')}}</label>
                    <div v-if="!valid_moved" class="invalid-feedback">
                        {{$t('valid_recently_moved')}}
                    </div>
                </div>
            </fieldset>

        <fieldset v-if="recently_moved ==='Yes'">
            <legend>{{$t('previous_address')}}</legend>
            <div class="form-row">

                <div class="col mb-3">

                    <div class="row">

                        <div class="col"><label for="prevStreetNumber">{{$t('street_number')}}</label></div>

                    </div>

                    <div class="row">

                        <div class="col-md-3">

                            <input id="prevStreetNumber" v-model="prev_street_number" autocomplete="off" type="text" class="form-control" required>

                        </div>

                    </div>

                </div>

            </div>

            <div class="form-row">

                <div class="col-md-5 mb-3">

                    <label for="prevStreetName">{{$t('street_name')}}</label>

                    <input id="prevStreetName" v-model="prev_street_name" autocomplete="off" type="text" class="form-control" required>

                    <small class="form-text text-muted">

                        {{$t('street_name_note')}}

                    </small>

                </div>

                <div class="col-md-4 mb-3">

                    <label for="prevStreetType">{{$t('street_type')}}</label>

                    <input id="prevStreetType" v-model="prev_street_type" autocomplete="off" type="text" class="form-control" required>

                    <small class="form-text text-muted">

                        {{$t('street_type_note')}}

                    </small>

                </div>

            </div>
        </fieldset>


            <div class="row no-gutters">
                <div class="col"><button class="btn btn-outline-secondary mt-4 float-right" @click="prev_step">{{$t('previous')}}</button></div>
                <div class="col-auto"><button class="btn btn-secondary mt-4 ml-3" @click="next_step">{{$t('next')}}</button></div>
            </div>

            <!-- ***** end custom content ***** -->
        </form>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                first_name: null,
                last_name: null,
                birth_month: null,
                birth_day: null,
                birth_year: null,
                term: null,
                address: null,
                street_number: null,
                street_name: null,
                street_type: null,
                recently_moved: null,
                prev_street_number: null,
                prev_street_name: null,
                prev_street_type: null,
            }
        },
        created: function () {
            this.personal_info = this.$store.getters.PERSONAL_INFO;

            if (this.personal_info.length > 0) {
                let info = this.personal_info[0];

                this.first_name = info.first_name;
                this.last_name = info.last_name;
                this.birth_day = info.birth_day;
                this.birth_month = info.birth_month;
                this.birth_year = info.birth_year;

                this.street_name = info.street_name;
                this.street_number = info.street_number;
                this.street_type = info.street_type;

                this.prev_street_number = info.prev_street_number;
                this.prev_street_name = info.prev_street_name;
                this.prev_street_type = info.prev_street_type;
                if (info.recently_moved === "Yes" || info.recently_moved === "No") {
                    this.recently_moved = info.recently_moved;
                }
                this.address = info.address;
            }
        },

        computed: {
            validate_day: function () {
                return ((this.birth_day !== null) && (parseInt(this.birth_day, 10) > 0 && parseInt(this.birth_day, 10 ) < 32));
            },
            validate_year: function () {
                return ((this.birth_year !== null) && this.birth_year > 1900)
            },
            validate_month: function () {
                return (this.birth_month !== null);
            },
            validate_first: function () {
                return (this.first_name !== null && this.first_name !== "");
            },
            validate_last: function () {
                return ((this.last_name !== null) && (this.last_name !== ""));
            },
            valid_without_address: function () {
                return (this.validate_day && this.validate_year && this.validate_month && this.validate_first && this.validate_last);
            },
            valid_home: function () {
                return (this.street_number && (this.street_number.length > 0) && this.street_name && (this.street_name.length > 0));
            },
           valid_address: function () {
                return this.valid_home;
            },
            valid_previous: function () {
                return (this.recently_moved === "No" || (this.prev_street_number && (this.prev_street_number.length > 0) && this.prev_street_name && (this.prev_street_name.length > 0)));
            },
            valid_moved: function () {
                return (this.recently_moved == "No" || this.recently_moved === "Yes");
            },
            valid_form: function () {
                return !(this.valid_address && this.valid_without_address && this.valid_previous && this.valid_moved);
            }
        },

        methods: {
            next_step: function () {
                // Fetch all the forms we want to apply custom Bootstrap validation styles to
                var forms = document.getElementsByClassName('needs-validation');
                // Loop over them and prevent submission
                var validation = false;

                Array.prototype.filter.call(forms, function (form) {
                    validation = form.checkValidity();
                    
                    if (form.checkValidity() === false) {
                        event.preventDefault();
                        event.stopPropagation();
                    }
                    form.classList.add('was-validated');
                });

                if (validation === true) {
                    var voter = {
                        first_name: this.first_name,
                        last_name: this.last_name,
                        birth_month: this.birth_month,
                        birth_year: this.birth_year,
                        birth_day: this.birth_day,
                        street_number: this.street_number,
                        street_name: this.street_name,
                        street_type: this.street_type,
                        prev_street_number: this.prev_street_number,
                        prev_street_name: this.prev_street_name,
                        prev_street_type: this.prev_street_type,
                        recently_moved: this.recently_moved,
                        address: this.address
                    };
                    //this.$store.commit('update_voter', voter);
                    this.$store.dispatch("SAVE_PERSONAL_INFO", voter);

                    this.$router.push({ name: "Step3", params: {page_type: this.$route.params.page_type, voter_id: this.$route.params.voter_id} });
                    //bus.$emit('change-tab', tran('register_vote_three'));
                }
            },
            prev_step: function () {
                this.$router.push({ name: "Step1", params: { page_type: this.$route.params.page_type, voter_id: this.$route.params.voter_id } });
            }
        }

    }
</script>
